module.exports = __webpack_public_path__ + "img/addTakeaway_01 .4262b76f.png";